import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74a73a1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "requirements" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Steps to Join", -1))

import { computed, ref } from 'vue';
import { GiveawayRequirementType } from '@manifoldxyz/redeem-client';
import ConnectWallet from '@/components/ConnectWallet.vue';
import InfoDisplay from '@/components/InfoDisplay.vue';
import TwitterUsernameInput from '@/components/requirements/TwitterUsernameInput.vue';
import { useClaimStore } from '../../store/claimStore';
import Requirement from './Requirement.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequirementsSection',
  setup(__props) {

const store = useClaimStore();

// List of requirement types that should be visible on UI
const visibleRequirementTypes = [
  GiveawayRequirementType.TWITTER_FOLLOW,
  GiveawayRequirementType.TWITTER_LIKE,
  GiveawayRequirementType.TWITTER_RETWEET,
  GiveawayRequirementType.EMAIL,
];

const flatRequirements = computed(() =>
  store.flatRequirements.filter((requirement) => {
    return visibleRequirementTypes.includes(requirement.type);
  })
);

const buttonLoading = ref(false);

/**
 * Show errors on requirements that are not shown on the UI
 */
const error = computed(() => {
  const incompleteRequirements = store.flatRequirements.filter((requirement) => {
    return !visibleRequirementTypes.includes(requirement.type) && !requirement.complete;
  });

  if (incompleteRequirements.length > 0) {
    // We always want to show allowlist errors first
    const incompleteAllowListRequirement = incompleteRequirements.find(
      (requirement) => requirement.type === GiveawayRequirementType.ALLOWLIST
    );
    if (incompleteAllowListRequirement) {
      return {
        error: incompleteAllowListRequirement.error || 'You are not in the allowlist',
      };
    } else {
      // Only show one error at a time
      const incompleteAllowRequirement = incompleteRequirements[0];
      const isNonZeroBalance =
        incompleteAllowRequirement.type === GiveawayRequirementType.NONZERO_BALANCE;
      return {
        error:
          incompleteAllowRequirement.error ||
          (isNonZeroBalance
            ? `A non-zero wallet balance is required to proceed. Add funds to ${store.ensOrFormattedWalletAddress} or switch wallets.`
            : 'Requirement not met'),
        primaryButtonProps:
          isNonZeroBalance && !incompleteAllowRequirement.error
            ? {
                text: "I've added funds",
                loading: buttonLoading.value,
                onClick: async () => {
                  buttonLoading.value = true;
                  await store.refreshSignup(true);
                  buttonLoading.value = false;
                },
              }
            : undefined,
      };
    }
  }
  return undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (error.value && !!_unref(store).signup)
      ? (_openBlock(), _createBlock(InfoDisplay, {
          key: 0,
          description: error.value.error,
          "primary-button-props": error.value.primaryButtonProps,
          type: "error"
        }, null, 8, ["description", "primary-button-props"]))
      : _createCommentVNode("", true),
    (_unref(store).status === 'active')
      ? (_openBlock(), _createBlock(ConnectWallet, { key: 1 }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatRequirements.value, (requirement, index) => {
      return (_openBlock(), _createBlock(Requirement, {
        key: index,
        requirement: requirement,
        disabled: _unref(store).disabled
      }, null, 8, ["requirement", "disabled"]))
    }), 128)),
    (_unref(store).hasTwitterRequirements)
      ? (_openBlock(), _createBlock(TwitterUsernameInput, {
          key: 2,
          disabled: _unref(store).disabled
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).emailRequirements, (requirement, index) => {
      return (_openBlock(), _createBlock(Requirement, {
        key: index,
        requirement: requirement,
        disabled: _unref(store).disabled
      }, null, 8, ["requirement", "disabled"]))
    }), 128))
  ]))
}
}

})